module.exports = __webpack_public_path__ + "img/arrow-left-circle.3b0173d0.svg";